// This file defines the application's configuration structure and provides a way
// to set it at runtime. The actual loading and validation of the configuration
// is handled by the `config/loader.ts` module.

export interface AuthConfig {
  userPoolId: string;
  userPoolClientId: string;
  region: string;
  domain?: string;
}

export interface ApiConfig {
  baseUrl: string;
  adminBaseUrl: string;
  timeout: number;
}

export interface AppConfig {
  auth: AuthConfig;
  api: ApiConfig;
  environment: 'development' | 'staging' | 'production';
  isDevelopment: boolean;
  isStaging: boolean;
  isProduction: boolean;
}

// A placeholder for the configuration that will be populated at runtime.
// It is exported so other modules can import it.
let appConfig: AppConfig;

/**
 * Sets the global application configuration. This function should only be
 * called once during the application's initialization process.
 * @param {AppConfig} config - The fully validated application configuration.
 */
export function setAppConfig(config: AppConfig): void {
  if (appConfig) {
    // This prevents the configuration from being accidentally changed later on.
    console.warn('Application configuration has already been set. Ignoring subsequent calls.');
    return;
  }
  appConfig = config;
  Object.freeze(appConfig); // Make the configuration immutable
}

// Export the (initially undefined) appConfig and the setter function.
export { appConfig };